import { render } from "./v-border-button.vue?vue&type=template&id=b10d5b8c&scoped=true"
import script from "./v-border-button.vue?vue&type=script&lang=js"
export * from "./v-border-button.vue?vue&type=script&lang=js"

import "./v-border-button.vue?vue&type=style&index=0&id=b10d5b8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10d5b8c"]])

export default __exports__